import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { EAccessType } from "@app/shared/auth/enums/auth.enum";
import { AuthApiService } from "@app/shared/auth/services/auth-api.service";
import { AuthTokenService } from "@app/shared/auth/services/auth-token.service";
import { AuthService } from "@app/shared/auth/services/auth.service";
import { map, switchMap, Observable } from "rxjs";

/**
 * Functional resolver to initiate 2FA recovery OTP verification.
 */
export const initiate2FaRecovery: ResolveFn<void> = (): Observable<void> | void => {
  const authApiService = inject(AuthApiService);
  const authService = inject(AuthService);
  const authTokenService = inject(AuthTokenService);

  if (authTokenService.getAccessTokenPayload()?.accessType !== EAccessType.VerifyLoginByRecoveryOtp) {
    return authApiService.initiateVerifyLoginBy2FaRecoveryOtp().pipe(
      switchMap(userAccess => authService.setUserAccess(userAccess)),
      map(() => void 0)
    );
  }
};
